export enum LoanType {
  InterestOnly,
  Repayment,
  InterestPartAndPart,
}
